module.exports = __webpack_public_path__ + "img/receipt_tip1.a8f009cc.png";